import React from 'react'

export const FrabchisingSent = ({ sendAnotherEmail }) => {
  return (
    <div className="msg-send" id="contact_form_send_success">
        <span className="ttl">
            Successfully sent!
        </span>
        <p>
            A bottle with your message in it is already on its way to us. As soon as we get your parchment, we will hurry to answer.
        </p>
        <button onClick={() => sendAnotherEmail(true)} className="btn btn-primary">Send another</button>
    </div>
  )
}
